import React from 'react'
import { SkeletonBase } from '../SkeletonBase'
import './SkeletonWindow.sass'

export const SkeletonWindow = () => {
  return <SkeletonBase type='text' className='skeleton-window' />
}
